export default __webpack_public_path__ + "static/media/whatsappqr.d58fc8df.jpg";